module.exports = __webpack_public_path__ + "img/tasks.0c455a0e.svg";